module.exports = __webpack_public_path__ + "img/support-active.55ab87a3.svg";